import React from "react";
import PAh2 from "../PAh2";
import "../../solutions/public/css/xsolla-solutions.css";
import { FormGroup } from "xsolla-uikit";
import "./overview.css";
import { Link } from "react-router-dom";
import { xsollaProducts } from '../../data/xsollaProducts';
import { PAoverUpgrade } from "./PAoverUpgrade";



export const PAprojectPath = ({children = 'Demo team'}) => (
  <div className="l_flex" style={{flexGrow:1}}>
    <Link to='/dashboard/team'  className="l_flex">

      {children}

      <div className="pa_prj_level_0_icon" style={{fontSize: 24}}>
        <div className="pa_prj_icon">
          chevron_right
        </div>
      </div>
    </Link>
    <div className="pa_prj_selector pa_prj_selector--active">
      <div className="pa_prj_selector_h1">
        <div>Early Access Game Demo</div>
      </div>
      <div className="pa_prj_projectid">
        <div className="pa_prj_project_status ok" />
        <div>Project ID: DEMO_EARLY_ACCESS</div>
      </div>
      <div className="pa_prj_clone0">
        <div className="pa_prj_clone">
          <div className="pa_prj_clonebut">
            <div className="pa_prj_icon">library_add</div>
          </div>
          <div>Clone project</div>
        </div>
      </div>
    </div>

  </div>
);




export const PAoverProjectPath = ({children = 'Demo team'}) => (
  <div className="pa_prj_bread">
    <Link to='/dashboard/team' className="pa_prj_level0">

      {children}

      <div className="pa_prj_level_0_icon">
        <div className="pa_prj_icon">
          chevron_right
        </div>
      </div>
    </Link>
    <div className="pa_prj_selector pa_prj_selector--active">
      <div className="pa_prj_selector_h1">
        <div>Early Access Game Demo</div>
      </div>
      <div className="pa_prj_projectid">
        <div className="pa_prj_project_status ok" />
        <div>Project ID: DEMO_EARLY_ACCESS</div>
      </div>
      <div className="pa_prj_clone0">
        <div className="pa_prj_clone">
          <div className="pa_prj_clonebut">
            <div className="pa_prj_icon">library_add</div>
          </div>
          <div>Clone project</div>
        </div>
      </div>
    </div>
    <div className="pa_prj_selector">
      <div className="pa_prj_selector_h1">
        <div>Free 2 play Game Demo</div>
      </div>
      <div className="pa_prj_projectid">
        <div className="pa_prj_project_status ok" />
        <div>Project ID: DEMO_FREE2PLAY</div>
      </div>
      <div className="pa_prj_clone0">
        <div className="pa_prj_clone">
          <div className="pa_prj_clonebut">
            <div className="pa_prj_icon">
              <div>library_add</div>
            </div>
          </div>
          <div>Clone project</div>
        </div>
      </div>
    </div>
  </div>
);

export const PAoverMenu = ({ awards = true, cards = true }) => (            <div className="pa_prj_menu">
<div className="pa_prj_menu">
  <div className="pa_prj_topmenu-left">
    <div className="pa_prj_topmenu_li pa_prj_topmenu_li--active">
      <div>Project Status</div>
    </div>

    <Link to="/dashboard/modules" className="pa_prj_topmenu_li">
      <div>Modules</div>
      <div className="pa_prj_counter">
        <div>4/9</div>
      </div>
    </Link>

    <Link to="/support/users" className="pa_prj_topmenu_li">
      <div>Users and Customers</div>
      <div className="pa_prj_counter">
        <div>3,341</div>
      </div>
    </Link>

    <div className="pa_prj_topmenu_li">
      <div>API Reference</div>
      <div className="pa_prj_invitedev">
        <div className="pa_prj_icon">
          <div>person_add</div>
        </div>
        <div className="pa_prj_clone0">
          <div className="pa_prj_clone pa_prj_clone--invite">
            <div className="pa_prj_clonebut">
              <div className="pa_prj_icon">
                <div>email</div>
              </div>
            </div>
            <div>Invite developer</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div className="pa_prj_topmenu-right" />
</div>
</div>)

export const PAoverTop = (props) => {
  const {project} = {...props}
return (
  <div className='pa_prj_top'>
    <div className="pa_prj_line">
      <div className="pa_prj_cols pa_prj_cols--2">
        <div>
          <div>
            <div>
              <div className="pa_prj_balance_sum">
                {project['name']}
              </div>
            </div>
          </div>
          <div className="pa_prj_cols pa_prj_cols--3">
            <div>
              <div className="pa_prj_label">
                <div>Stage</div>
              </div>
              <div className="pa_prj_entry">
                {project['stage']}
              </div>
            </div>
            <div>
              <div>
                <div className="pa_prj_label">
                  <div>MonetiZation</div>
                </div>
              </div>
              <div className="pa_prj_entry">
                {project['monetization'].map((one, ind)=>

                  `${xsollaProducts[one]['name']}${ind === project['monetization'].length - 1 ? '' : ', '}`)}

              </div>
            </div>
            <div>
              <div>
                <div className="pa_prj_label">
                  <div>Platforms</div>
                </div>
              </div>
              <div className="pa_prj_entry">
                {project['platforms']}
              </div>
            </div>
          </div>
        </div>
        <div id="w-node-99469127e72f-013218f7" className="pa_prj_balance">
          <div>
            <div className="pa_prj_label pa_prj_label--1">
              <div>Balance</div>
            </div>
          </div>
          <div className="pa_prj_cols pa_prj_cols--3balance">
            <div>
              <div className="pa_prj_balance_sum">
                {project['balance']}
              </div>
            </div>
            <div>
              <div className="pa_prj_label">
                <div>Last Payout date</div>
              </div>
              <div className="pa_prj_entry">
                <div>Jan 22, 2020</div>
              </div>
            </div>
            <div>
              <div className="pa_prj_label">
                <div>Next Payout date</div>
              </div>
              <div className="pa_prj_entry">
                <div>Jan 22, 2020</div>
              </div>
            </div>
          </div>
          <div className="pa_prj_balance_bg" />
        </div>
      </div>
    </div>
  </div>
)};

export const PAoverModulesMicro = () => (
  <div className="pa_prj_line">
    <div className="pa_prj_cols">
      <div className="pa_prj_cols">
        <div className="pa_prj_section">
          <div className="pa_prj_label pa_prj_label--1">
            <div>Selling</div>
          </div>
          <div className="pa_prj_ul">
            <Link to="/game_store/" className="pa_prj_entry0">
              <div className="pa_prj_entry">
                <div className="pa_prj_project_status not-ok" />
                <div>Game keys</div>
              </div>
              <div className="pa_prj_counter">
                <div>12 left</div>
              </div>
            </Link>

            <Link to="/subscriptions/plans/" className="pa_prj_entry0">
              <div className="pa_prj_entry">
                <div className="pa_prj_entry">
                  <div className="pa_prj_project_status ok" />
                  <div>Subscription plans</div>
                </div>
              </div>
              <div className="pa_prj_counter">
                <div>3</div>
              </div>
            </Link>


            <Link to="/game_store/goods/" className="pa_prj_entry0">
              <div className="pa_prj_entry">
                <div className="pa_prj_entry">
                  <div className="pa_prj_project_status ok" />
                  <div>Merchandise</div>
                </div>
              </div>
              <div className="pa_prj_counter">
                <div>16</div>
              </div>
            </Link>



            <Link to="/microtransactions/virtual_currency/" className="pa_prj_entry0">
              <div className="pa_prj_entry">
                <div className="pa_prj_entry pa_prj_entry--inactive">
                  <div className="pa_prj_project_status inactive" />
                  <div>Virtual Currency</div>
                </div>
              </div>
            </Link>

            <Link to="/microtransactions/virtual_items/" className="pa_prj_entry0">
              <div className="pa_prj_entry">
                <div className="pa_prj_entry pa_prj_entry--inactive">
                  <div className="pa_prj_project_status inactive" />
                  <div>Virtual Items</div>
                </div>
              </div>
            </Link>

          </div>
        </div>
        <div className="pa_prj_section">
          <div className="pa_prj_label pa_prj_label--1">
            <div>Means of distribution</div>
          </div>

          <div>

          <Link to="/site_builder/start/" className="pa_prj_entry0">
            <div className="pa_prj_entry">
              <div className="pa_prj_entry">
                <div className="pa_prj_project_status ok" />
                <div>Landing page</div>
              </div>
              </div>
            </Link>

            <Link to='/game_store' className="pa_prj_entry0">
              <div className="pa_prj_entry">
                <div className="pa_prj_entry">
                  <div className="pa_prj_project_status ok" />
                  <div>Copy-paste button</div>
                </div>
              </div>
              <div className="pa_prj_copybutton">
                <div className="pa_prj_icon">
                  <div>link</div>
                </div>
              </div>
            </Link>

            <Link to='/launcher' className="pa_prj_entry0">
              <div className="pa_prj_entry">
                <div className="pa_prj_entry pa_prj_entry--inactive">
                  <div className="pa_prj_project_status inactive" />
                  <div>Launcher</div>
                </div>
              </div>
            </Link>


          </div>
        </div>
      </div>
      <div className="pa_prj_cols">
        <div className="pa_prj_section">
          <div className="pa_prj_label pa_prj_label--1">
            <div>Essentials</div>
          </div>
          <div className="pa_prj_ul">


            <Link to='/login' className="pa_prj_entry0">
              <div className="pa_prj_label">
                <div>Authorization</div>
              </div>
              <div className="pa_prj_entry">
                <div className="pa_prj_entry">
                  <div className="pa_prj_project_status ok" />
                  <div>OAuth™</div>
                </div>
              </div>
            </Link>

            <Link to='/paystation' className="pa_prj_entry0">
              <div className="pa_prj_label">
                <div>Payments</div>
              </div>
              <div className="pa_prj_entry">
                <div className="pa_prj_entry">
                  <div className="pa_prj_project_status not-ok" />
                  <div>Xsolla Pay Station</div>
                </div>
              </div>
            </Link>


            <Link to='/antifraud' className="pa_prj_entry0">
              <div className="pa_prj_label">
                <div> </div>
              </div>
              <div className="pa_prj_entry">
                <div className="pa_prj_entry">
                  <div className="pa_prj_project_status ok" />
                  <div>Xsolla Antifraud</div>
                </div>
              </div>
            </Link>


          </div>
        </div>
      </div>
    </div>
  </div>
);

export function PAprojectOverview(props) {

  const {
    menu = true,
    image = true,
    top = true,
    modulesMicro = true,
    modules = true,
    upgrades = true,
    awards = true,
    cards = true,
    teamDashboard = false,
    project,
  } = {...props};

  return (
    <div className="l_block ">
      <div className="l_content l_content--pa">
        <div className="l_block_bg l_block_bg--100 ">
          {!teamDashboard && <div className="l_block_bg l_block_bg--pahead" />}
          <div className="l_block_bg l_block_bg--deep-blue" />
        </div>
        <div className="pa_prj">


         {/* {image && <div className="pa_prj_hero">
            <div className="l_block_bg l_block_bg--hero1" />

            <PAoverProjectPath {...props} />

            <div className="pa_prj_hero_right">
              <div className="pa_prj_hero_sett">
                <div className="pa_prj_icon">
                  <div>settings</div>
                </div>
              </div>
            </div>
            {menu && <PAoverMenu {...props}/>}
          </div>} */}

          {/* <div className="l_block_bg l_block_bg--pa-blue" /> */}
          <div className="pa_project">
            <div className="l_block_bg l_block_bg--pa-blue xsui-content-block--appearance-primary" />

            {top && !teamDashboard &&<PAoverTop {...props} />}

            {top && teamDashboard &&
            <Link to='/dashboard/all'>
            <PAoverTop
              project={project}
            /></Link>}


            {modulesMicro && <PAoverModulesMicro {...props} />}

            {upgrades && <PAoverUpgrade {...props} cards={cards} />}
          </div>
        </div>
        <div className="p_formgroup_lg" />
      </div>
    </div>
  );
}
